import { Component, OnInit } from '@angular/core';
import { ActiveModal } from '@healthcatalyst/cashmere';
import { CustomUserClaims, UserClaims } from '@okta/okta-auth-js';

export interface TenantLocationRolesClaims extends CustomUserClaims {
    location: string;
    tenant_id: string;
    roles: string[];
    last_login: string;
}

@Component({
    templateUrl: './user-detail-modal.component.html',
    styleUrl: './user-detail-modal.component.scss',
    standalone: false
})
export class UserDetailModalComponent implements OnInit {
    public userInfo: UserClaims<TenantLocationRolesClaims>;

    constructor(public activeModal: ActiveModal) {}

    ngOnInit() {
        this.userInfo = this.activeModal.data;
        this.userInfo?.roles.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    }

    close(): void {
        this.activeModal.close();
    }
}
